import React, {
  useState,
  useCallback,
  useEffect,
  useReducer,
} from "react";
import { useTranslation } from "react-i18next";
import Joi from "joi";
import { Spinner, DialogComponent } from "../../../../../Components";
import { showError, showSuccess, showWarn } from "../../../../../Helper";
import {
  GetLookupItemsByLookupTypeName,
  UpdateVendorClientTracking,
  GetVendorClientTrackingByIdAPI,
} from "../../../../../Services";
import { ClientsTrackingContentDialog } from "./ClientsTrackingContentDialog/ClientsTrackingContentDialog";

export const ClientsTrackingManagementDialog = ({
  parentTranslationPath,
  translationPath,
  isOpen,
  onClose,
  onSave,
  vendorClientTrackingId,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const reducer = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);
  const reducer2 = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);

  const [data, setData] = useReducer(reducer, {
    psiCommissionStatus: [],
    transactionStatusClientTracking: [],
  });

  const [defaultState, setDefaultState] = useState({
    vendorClientTrackingId: null,
    vendorOfferId: null,
    vendorOfferName: null,
    vendorName: null,
    vendorId: null,
    contactName: null,
    contactId: null,
    serviceId: null,
    serviceName: null,
    psiCommissionPercentage: null,
    psiCommissionStatusName: null,
    psiCommissionStatusId: null,
    qrCode: null,
    promoCode: null,
    discountPercentage: null,
    invoiceId: null,
    createdOn: null,
    transactionStatusName: null,
    transactionStatusId: null,
    clientFeedback: null,
    transactionAmount: null,
    vendorServiceCategoryId: null,
    vendorServiceCategoryName: null,
    offerStatus: null,
  });

  const [defaultSelected, setDefaultSelected] = useState({
    psiCommissionStatus: null,
    transactionStatus: null,
  });

  const reducer3 = (select, action) => {
    if (action.id !== "edit") return { ...select, [action.id]: action.value };
    if (action.id === "edit") {
      return {
        ...action.value,
      };
    }
  };

  const reducer4 = (select, action) => {
    if (action.id !== "edit") return { ...select, [action.id]: action.value };
    if (action.id === "edit") {
      return {
        ...action.value,
      };
    }
  };

  const [state, setState] = useReducer(reducer3, {
    ...defaultState,
  });

  const [selected, setSelected] = useReducer(reducer4, {
    ...defaultSelected,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [activeData, setActiveData] = useState(null);
  const [isLoadingData, setIsLoadingData] = useReducer(reducer2, {
    clientTrackingInfo: false,
    save: false,
    psiCommissionStatus: false,
    transactionStatusClientTracking: false,
  });

  const schema = Joi.object({
    vendorOfferId: Joi.number()
      .required()
      .messages({
        "number.empty": t(`${translationPath}vendor-offer-is-required`),
        "number.base": t(`${translationPath}vendor-offer-is-required`),
        "number.required": t(`${translationPath}vendor-offer-is-required`),
      }),
    contactId: Joi.number()
      .required()
      .messages({
        "number.empty": t(`${translationPath}client-is-required`),
        "number.base": t(`${translationPath}client-is-required`),
        "number.required": t(`${translationPath}client-is-required`),
      }),
    psiCommissionStatusId: Joi.number()
      .required()
      .messages({
        "number.empty": t(
          `${translationPath}psi-commission-status-is-required`
        ),
        "number.base": t(`${translationPath}psi-commission-status-is-required`),
        "number.required": t(
          `${translationPath}psi-commission-status-is-required`
        ),
      }),
    transactionStatusId: Joi.number()
      .required()
      .messages({
        "number.empty": t(`${translationPath}transaction-status-is-required`),
        "number.base": t(`${translationPath}transaction-status-is-required`),
        "number.required": t(
          `${translationPath}transaction-status-is-required`
        ),
      }),
  })
    .options({
      abortEarly: false,
      allowUnknown: true,
    })
    .validate(state);

  const GetLookupItemsByNames = useCallback(async (key, lookupName) => {
    setIsLoadingData({ id: [key], value: true });
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: lookupName,
      pageSize: 1000,
      pageIndex: 1,
    });
    if (!(res && res.status && res.status !== 200)) {
      setData({ id: [key], value: res.result || [] });
    } else setData({ id: [key], value: [] });
    setIsLoadingData({ id: [key], value: false });
  }, []);

  const GetVendorClientTrackingById = useCallback(async () => {
    setIsLoadingData({ id: "clientTrackingInfo", value: true });
    const res = await GetVendorClientTrackingByIdAPI(vendorClientTrackingId);
    if (!(res && res.status && res.status !== 200)) {
      setActiveData({ ...res });
    } else setActiveData(null);
    setIsLoadingData({ id: "clientTrackingInfo", value: false });
  }, [vendorClientTrackingId]);

  const onCloseClicked = () => {
    onClose();
    setSelected({ id: "edit", value: defaultSelected });
    setState({ id: "edit", value: defaultState });
  };

  const saveHandler = useCallback(async () => {
    setIsSubmitted(true);
    setIsLoadingData({ id: "save", value: true });

    if (schema.error) {
      showError(t("Shared:please-fix-all-errors"));
      setIsLoadingData({ id: "save", value: false });
      return;
    }

    if (
      selected?.psiCommissionStatus?.lookupItemName === "Paid" &&
      (!state.transactionAmount ||
        state.transactionAmount === "" ||
        state.transactionAmount === 0)
    ) {
      showWarn(
        t(
          `${translationPath}transaction-amount-must-be-recorded-before-marking-psi-commission-status-as-paid`
        )
      );
      setIsLoadingData({ id: "save", value: false });
      return;
    }
    if (
      selected?.transactionStatus?.lookupItemName === "Completed" &&
      (!state.invoiceId || state.invoiceId === "" || state.invoiceId === 0)
    ) {
      showWarn(
        t(
          `${translationPath}invoice-number-must-be-recorded-with-marking-transaction-status-is-completed`
        )
      );
      setIsLoadingData({ id: "save", value: false });
      return;
    }

    try {
      const result = await UpdateVendorClientTracking(
        vendorClientTrackingId,
        state
      );
      if (result) {
        showSuccess(t(`${translationPath}update-client-tracking-successfully`));
        setIsLoadingData({ id: "save", value: false });
      }
      onSave(result);
    } catch (error) {
      showError(error?.message || t(`${translationPath}error-occurred`));
    } finally {
      setIsLoadingData({ id: "save", value: false });
    }
  }, [schema.error, state, selected]);

  useEffect(() => {
    if (vendorClientTrackingId) {
      GetVendorClientTrackingById();
    }
  }, [vendorClientTrackingId]);

  useEffect(() => {
    GetLookupItemsByNames("psiCommissionStatus", "PsiCommissionStatus");
    GetLookupItemsByNames(
      "transactionStatusClientTracking",
      "TransactionStatusClientTracking"
    );
  }, []);

  useEffect(() => {
    if (activeData && activeData.vendorClientTrackingId) {
      setState({ id: "edit", value: activeData });
      const selectedData = {
        ...selected,
        psiCommissionStatus: {
          lookupItemId: activeData?.psiCommissionStatusId,
          lookupItemName: activeData?.psiCommissionStatusName,
        },
        transactionStatus: {
          lookupItemId: activeData?.transactionStatusId,
          lookupItemName: activeData?.transactionStatusName,
        },
      };
      setSelected({ id: "edit", value: selectedData });
    } else {
      setState({ id: "edit", value: defaultState });
      setSelected({ id: "edit", value: defaultSelected });
    }
  }, [activeData]);

  return (
    <DialogComponent
      titleText="update-client-tracking"
      titleClasses="activities-management-dialog-title"
      saveText="save"
      saveType="button"
      className="activities-management-dialog-wrapper"
      maxWidth="sm"
      disableBackdropClick
      dialogContent={
        <div className="dialog-content-wrapper">
          <Spinner
            isActive={isLoadingData.save || isLoadingData.clientTrackingInfo}
            isAbsolute
          />
          <ClientsTrackingContentDialog
            data={data}
            state={state}
            setState={setState}
            selected={selected}
            setSelected={setSelected}
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
            isSubmitted={isSubmitted}
            schema={schema}
          />
        </div>
      }
      saveClasses="btns theme-solid w-100 mx-2 mb-2"
      isOpen={isOpen}
      onSaveClicked={() => {
        saveHandler();
      }}
      onCloseClicked={onCloseClicked}
      onCancelClicked={onCloseClicked}
      parentTranslationPath={parentTranslationPath}
      translationPath={translationPath}
      saveIsDisabled={
        isLoadingData.save ||
        isLoadingData.clientTrackingInfo
      }
    />
  );
};
